import { render, staticRenderFns } from "./PurchaseRequestHistoryModal.vue?vue&type=template&id=74e4f4ec"
import script from "./PurchaseRequestHistoryModal.vue?vue&type=script&lang=js"
export * from "./PurchaseRequestHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports